export enum CRVSDocumentTypes {
  CHILD_ID = 'CHILD_ID',
  NID = 'NID',
  NIN = 'NIN',
  NID_APPLICATION_NUMBER = 'NID_APPLICATION_NUMBER',
  PASSPORT = 'PASSPORT',
  FOREIGN_ID = 'FOREIGN_ID',
  UNHCR_PROOFOFREGISTRATION = 'UNHCR_PROOFOFREGISTRATION',
}

export interface ICRVSDocumentTypeDefinition {
  label: string;
  value: CRVSDocumentTypes;
  pattern: string;
  maxLength?: number;
  minLength?: number;
}

export const CRVS_DOCUMENT_TYPE_DEFINITIONS: Record<
  CRVSDocumentTypes,
  ICRVSDocumentTypeDefinition
> = {
  [CRVSDocumentTypes.NID]: {
    label: 'National ID',
    value: CRVSDocumentTypes.NID,
    pattern: '^\\d{16,}$',
    maxLength: 16,
    minLength: 16,
  },
  [CRVSDocumentTypes.CHILD_ID]: {
    label: 'Child ID',
    value: CRVSDocumentTypes.CHILD_ID,
    pattern: '^\\d{8,}$',
    maxLength: 8,
    minLength: 8,
  },
  [CRVSDocumentTypes.NIN]: {
    label: 'NIN',
    value: CRVSDocumentTypes.NIN,
    pattern: '^\\d{10,}$',
    maxLength: 10,
    minLength: 10,
  },
  [CRVSDocumentTypes.NID_APPLICATION_NUMBER]: {
    label: 'NID APPLICATION NUMBER',
    value: CRVSDocumentTypes.NID_APPLICATION_NUMBER,
    pattern: '^\\d*$',
    maxLength: 8,
    minLength: 8,
  },
  [CRVSDocumentTypes.PASSPORT]: {
    label: CRVSDocumentTypes.PASSPORT,
    value: CRVSDocumentTypes.PASSPORT,
    pattern: '^[a-zA-Z0-9]*$',
    maxLength: 10,
    minLength: 5,
  },
  [CRVSDocumentTypes.FOREIGN_ID]: {
    label: 'FOREIGN ID',
    value: CRVSDocumentTypes.FOREIGN_ID,
    pattern: '^[a-zA-Z0-9]*$',
    maxLength: 10,
    minLength: 5,
  },
  [CRVSDocumentTypes.UNHCR_PROOFOFREGISTRATION]: {
    label: 'UNHCR PROOF OF REGISTRATION',
    value: CRVSDocumentTypes.UNHCR_PROOFOFREGISTRATION,
    pattern: '^\\d*$',
    maxLength: 12,
    minLength: 12,
  },
};
